import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TransitionGroup } from 'react-transition-group';

import {
    ContainerStyled,
    LegalInfoWrapper,
    FormWrapper
} from '../../containers/DefaultStyles/AssessmentDetails';

import CssTransition from '../../components/Transition/CssTransition';
import ElectionReminderForm from '../../components/ElectionReminder/ElectionReminderForm';
import LegalInfo from '../../components/Widget/LegalInfo';
import ToasterAlert from '../../components/Donation/ToasterAlert';
import TransitionContainer from '../../components/Transition/TranstionContainer';
import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import { onGoToNextCard } from '../Widget/actions';
import { onGoToStartScreen, submitElectionReminderForm } from './actions';

import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';
import { cacheFormData } from '../../utils/formCaching/actions';
import { getActionCompletedTime } from '../../utils/actionTiming';
import { CardTypes } from '../../utils/enums';

const sidebarDescriptionText = `Sign up for reminders to never miss an election! \
    You’ll receive nonpartisan reminders for upcoming primaries, \
    elections, and special elections.`;

const ElectionReminderDetails = props => (
    <TransitionContainer isSubmitting={props.isFormSubmitting} zIndex={2}>
        <ContainerStyled>
            <VoteRegistrationSidebar
                title={'Election Reminders Sign Up'}
                description={sidebarDescriptionText}
                showReceiveUpdates={true}
            />
            <FormWrapper isElectionReminder={true}>
                <ElectionReminderForm
                    onBack={() => {
                        props.onGoToStartScreen(props.actionIdentifier);
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        if (props.skipEndCard) {
                            props.handleSkippingEndCard(
                                props.nextAction,
                                props.cards,
                                props.onGoToNextCard
                            );
                        }
                        props.submitElectionReminderForm(
                            props.apiRequestData,
                            values,
                            props.isMultiActionsCard,
                            props.actionIdentifier,
                            props.actionCompletedTime(),
                            props.skipEndCard
                        );
                    }}
                    isFormSubmitting={props.isFormSubmitting}
                />
                {props.isMobileResolution && (
                    <LegalInfoWrapper>
                        <LegalInfo />
                    </LegalInfoWrapper>
                )}
            </FormWrapper>
            <TransitionGroup>
                {props.electionReminderError && (
                    <CssTransition key="alert" in={props.electionReminderError}>
                        <ToasterAlert content={props.electionReminderError} />
                    </CssTransition>
                )}
            </TransitionGroup>
            <TransitionGroup>
                {props.addressValidationError && (
                    <CssTransition key="alert" in={props.addressValidationError}>
                        <ToasterAlert content={props.addressValidationError} />
                    </CssTransition>
                )}
            </TransitionGroup>
        </ContainerStyled>
    </TransitionContainer>
);

ElectionReminderDetails.propTypes = {
    addressValidationError: PropTypes.any,
    nextAction: PropTypes.object,
    isMobileResolution: PropTypes.bool,
    apiRequestData: PropTypes.object.isRequired,
    isFormSubmitting: PropTypes.bool,
    onGoToStartScreen: PropTypes.func.isRequired,
    submitElectionReminderForm: PropTypes.func.isRequired,
    electionReminderError: PropTypes.string,
    isMultiActionsCard: PropTypes.bool.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    actionCompletedTime: PropTypes.func.isRequired,
    cards: PropTypes.array.isRequired,
    skipEndCard: PropTypes.bool,
    onGoToNextCard: PropTypes.func.isRequired,
    handleSkippingEndCard: PropTypes.func.isRequired,
    cacheFormData: PropTypes.func.isRequired
};

export default connect(
    state => {
        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            nextAction,
            addressValidationError: state.widget.addressValidationError,
            isMobileResolution: state.widget.isMobileResolution,
            apiRequestData: state.widget.apiRequestData,
            isFormSubmitting: state.electionReminder.isFormSubmitting,
            electionReminderError: state.electionReminder.electionReminderError,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            actionIdentifier: state.widget.activeAction.identifier,
            actionCompletedTime: getActionCompletedTime(state, 'electionReminder'),
            cards: state.widget.cards,
            skipEndCard: state.widget.activeAction.skipEndCard && !!nextAction
        };
    },
    {
        onGoToStartScreen,
        submitElectionReminderForm,
        onGoToNextCard,
        handleSkippingEndCard,
        cacheFormData
    }
)(ElectionReminderDetails);
